/**
 * Converts pasted URLs into links in a Trix editor.
 *
 * Example: %div{ data: {controller: "trix--editor trix--paste-link"} }
 *
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.boundPasteHandler = this.pasteHandler.bind(this);
    this.element.addEventListener("trix-paste", this.boundPasteHandler);
  }

  disconnect() {
    this.element.removeEventListener("trix-paste", this.boundPasteHandler);
  }

  pasteHandler(event) {
    const pastedText = event.paste?.string;
    if (
      !!pastedText &&
      !!pastedText.match(
        /^(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})$/gi,
      )
    ) {
      const editor = event.currentTarget.editor;
      const pasteRange = event.paste.range;
      // Defer so Trix finishes rendering the pasted text before we apply the link,
      // otherwise the link styling doesn't appear until the next input event.
      setTimeout(() => this.linkifyPaste(editor, pastedText, pasteRange), 0);
    }
  }

  linkifyPaste(editor, pastedText, pasteRange) {
    const selectionBeforeLinkify = editor.getSelectedRange();
    editor.recordUndoEntry("Auto Link Paste");
    editor.setSelectedRange(pasteRange);
    editor.activateAttribute("href", pastedText);
    editor.setSelectedRange(selectionBeforeLinkify);
    editor.deactivateAttribute("href");
  }
}
